<script lang="ts" setup>
    import { computed, ref } from 'vue';
    import { storeToRefs } from "pinia";
    import { useGenericStore } from "@/store/genericStore";
    import {
        richTextHasText,
        useRichTextFormatting
    } from "@/helpers/composables/builderFieldUtility.ts";
    import { useAnchorListener } from "@/helpers/composables/useAnchorListener";

    let props = defineProps({
        bg_color: {
            type: String,
            default: 'rothcoWhite'
        },
        text_color: {
            type: String,
            default: 'rothcoBlack'
        },
        seoText: {
            type: String,
            required: false
        },
        category: {
            type: Object
        },
        builderContext: {
            type: Object
        }
    });

    const bgColorClass = computed(()=>{
        return `bg-${props.bg_color || 'rothcoWhite'}`
    });

    const textColorClass = computed(()=>{
        return `text-${props.text_color || 'rothcoBlack'}`
    });

    const categorySeoName = computed(()=>{
        return props.builderContext?.content?.data?.category.seo_name ?? props.category?.seo_name ?? '';
    })

    const { state:categoryDataStore} = storeToRefs(useGenericStore(`categoryData-${categorySeoName.value}`));

    const componentContent = computed(()=>{
        let text = '';
        if(richTextHasText(props.seoText)){
            text = props.seoText;
        }else if(richTextHasText(categoryDataStore?.value?.seoText)){
            text = categoryDataStore?.value?.seoText;
        }
        return useRichTextFormatting(text);
    })

    const seoCopy = ref<HTMLElement | null>(null);
    useAnchorListener(seoCopy);

</script>
<template>
    <div :class="['seocopy category-landing', bgColorClass]">
        <div class="seocopy-content">
            <p ref="seoCopy" :class="['paragraph', textColorClass]" style="text-align: center" v-html="componentContent"></p>
        </div>
    </div>
</template>
